module.exports = __webpack_public_path__ + "img/icon_Architecture_B.9a1763a9.svg";